<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>

    <!-- Plugin -->
    <toast></toast>
    <!--<confirm></confirm>
      <wait></wait> -->

    <v-snackbar v-model="snackbar.visibile" :color="snackbar.tipo" timeout="4000" location="bottom">
      {{ snackbar.testo }}
      <template #actions>
        <v-btn variant="text" @click="$store.commit('app/hideMessage')">Chiudi</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { heartbeat } from '@/api/api.user';

export default {
  name: "App",

  mounted() {
    const interval = setInterval(() => {
      if (this.$store.getters['auth/isAuthenticated'])
        heartbeat();
    }, 10000);

    return () => clearInterval(interval);
  },

  computed: {
    snackbar() {
      return this.$store.state.app.snackbar
    }
  }
};
</script>
